export const ShareTypes = {
    STEP_PROFILE: 'STEP_PROFILE',
    POST_PROFILE: 'POST_PROFILE',
    MAP_ABOUT_VIEW: 'MAP_ABOUT_VIEW',
    MAP_MAP_VIEW: 'MAP_MAP_VIEW',
    MAP_FEED_VIEW: 'MAP_FEED_VIEW',
    USER_FEED_VIEW: 'USER_FEED_VIEW',
}